import UpdateDataError from './UpdateDataError';

export default UpdateDataError;
